import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.LeasePricing1, LocationVarKey.LeasePricing2, LocationVarKey.LeasePricing3];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Pricing
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.LeasePricing1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.LeasePricing2}
        enableSwitchVar={LocationVarKey.LeasePricing2Enabled}
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.LeasePricing3}
        enableSwitchVar={LocationVarKey.LeasePricing3Enabled}
      />
    </>
  );
}
